module.exports = __webpack_public_path__ + "img/Icon_Proveedor_Especialistas.ccc3cba1.svg";